export default abstract class BackendError extends Error {
  public abstract name: string;

  constructor(message: string) {
    super(message);
    console.error(`${this.constructor.name}: ${message}`);
  }
}
